import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap , timeout} from 'rxjs/operators';
import {LoginService} from '../services';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {  
  constructor(private loginService: LoginService) {}
  defaultTimeout = 180 * 1000;
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const timeoutValue = request.headers.get('timeout') || this.defaultTimeout;
    const timeoutValueNumeric = Number(timeoutValue);
    return next.handle(request).pipe(
      timeout(timeoutValueNumeric),
      tap(
        (event: HttpEvent<any>) => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              this.loginService.logout();
            }
          }
        }
      )
    );
  }
}
